import axios from '../api/client'

/**
 * Fire-and-forget engagement event to the activity beacon (`POST /api/activity`).
 * Server-side `logActivity` ignores admins, so admin noise never pollutes analytics.
 * The action must be in the server's allow-list (see server/index.ts).
 */
export function track(action: string, metadata?: Record<string, unknown>) {
  axios.post('/activity', { action, metadata }).catch(() => {})
}
